/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCashSuspended = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16.318 16.318a4.499 4.499 0 1 1 6.364 6.362 4.499 4.499 0 0 1-6.364-6.362zm2.269 5.508a2.499 2.499 0 0 0 3.24-3.24zm1.825-4.653a2.5 2.5 0 0 0-3.24 3.24z" />
        <path d="M22 13h-2V9.9A5.005 5.005 0 0 1 16.1 6H7.9A5.005 5.005 0 0 1 4 9.9v4.2A5.006 5.006 0 0 1 7.9 18H13v2H2V4h20zM4 18h1.826A3.003 3.003 0 0 0 4 16.174zM4 7.825A3.002 3.002 0 0 0 5.826 6H4zM18.174 6A3.002 3.002 0 0 0 20 7.825V6z" />
        <path d="M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgCashSuspended as CashSuspended };
